import _flowRight from 'lodash/flowRight';
import { normalize, denormalize } from 'normalizr';
import {
  changeStatus,
} from '@homeservices/api-kit/workorder/proreferral';
import { getJob } from '@homeservices/api-kit/proreferral/jobs/v6';

import { JOBS_WITH_APPOINTMENTS_SCHEMA, PRO_WORK_ORDERS } from '@/store/modules/entities';
import { withTakeLatest } from '@/utils/cancel-token';
import { withRequestLifecycle, REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

import notes from './notes';
import appointments from './appointments';
import files from './files';
import messages from './messages';

const MUTATION_KEY = 'patchJob';

export default {
  namespaced: true,
  modules: {
    notes,
    appointments,
    files,
    messages,
  },
  state: {
    current: {
      status: REQUEST_LIFECYCLE.UNINITIALIZED,
      error: null,
      result: '',
    },
  },
  getters: {
    currentJobMeta: (state) => {
      const { result, ...meta } = state.current;

      return meta;
    },
    currentRawJob: state => state.current.result,
    getJob: (_, __, { entities }) => id => denormalize(id, JOBS_WITH_APPOINTMENTS_SCHEMA, entities),
  },
  actions: {
    fetchJob: _flowRight(
      withTakeLatest('jobId'),
      withRequestLifecycle(MUTATION_KEY),
      () => async (context, { injected: { cancelToken, performFulfillment }, jobId }) => {
        const { data } = await getJob(jobId, cancelToken);

        return performFulfillment(normalize(data, PRO_WORK_ORDERS));
      }
    )(),
    transitionJob: _flowRight(
      withRequestLifecycle(MUTATION_KEY),
      () => async (
        { commit, dispatch },
        { injected: { performSideEffect }, from, to, action, order_hash, params = {} }
      ) => {
        await changeStatus(order_hash, action, params);

        if (from) {
          commit(
            'dashboard/workOrderMatches/transitionJob',
            { meta: { from, to, action, order_hash, params } },
            { root: true }
          );
        }
        performSideEffect(() =>
          dispatch(
            'dashboard/workOrderMatches/fetchWorkOrderMatches',
            { },
            { root: true }
          ));
      }
    )(),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      state.current = {
        ...state.current,
        ...payload,
      };
    },
  },
};
